import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import COLORS from "../../../constants/Colors";
import NearMeRoundedIcon from "@mui/icons-material/NearMeRounded";

const TrackingIndicationChip = ({ isTracking = true, compactMode = false }) => {
  return (
    <Box
      sx={{
        background: COLORS.TRACKING_GREEN,
        height: compactMode ? "18px" : "25px",
        borderRadius: "15px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        padding: compactMode ? "0.1rem 0.25rem" : "0.1rem 0.8rem",
      }}
    >
      <NearMeRoundedIcon
        sx={{
          color: "white",
          fontSize: compactMode ? "0.9rem" : "1rem",
        }}
      />
      {!compactMode && (
        <Typography
          fontSize={"0.9rem"}
          fontWeight={600}
          sx={{
            color: "white",
            ml: "0.2rem",
          }}
        >
          {isTracking ? "Tracking" : "Not Tracking"}
        </Typography>
      )}
    </Box>
  );
};

TrackingIndicationChip.propTypes = {
  isTracking: PropTypes.bool,
  compactMode: PropTypes.bool,
};

export default TrackingIndicationChip;
